var map = {
	"./baner-1.webp": 416,
	"./baner-10.webp": 417,
	"./baner-11.webp": 399,
	"./baner-12.webp": 418,
	"./baner-13.webp": 419,
	"./baner-14.webp": 420,
	"./baner-2.webp": 421,
	"./baner-3.webp": 422,
	"./baner-4.webp": 423,
	"./baner-5.webp": 424,
	"./baner-6.webp": 425,
	"./baner-61.webp": 426,
	"./baner-7.webp": 427,
	"./baner-8.webp": 428,
	"./baner-9.webp": 429
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 415;